import { render } from "./SingleSelect.vue?vue&type=template&id=54c5ca27"
import script from "./SingleSelect.vue?vue&type=script&lang=js"
export * from "./SingleSelect.vue?vue&type=script&lang=js"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__